<section class="page__section -small-bottom">
    <manage-messages></manage-messages>
</section>
